class EventsFilter extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.selectedOptions = [];
    this.selects = [];
  }

  connectedCallback() {
    this.initializeComponent();
  }

  initializeComponent() {
    this.renderTemplate();
    this.setupEventListeners();
  }

  renderTemplate() {
    this.shadowRoot.innerHTML = `<slot></slot>`;
  }

  setupEventListeners() {
    const slot = this.shadowRoot.querySelector('slot');
    slot.addEventListener('slotchange', this.handleSlotChange.bind(this));
  }

  handleSlotChange(event) {
    this.selects = event.target.assignedElements().filter((el) => el.tagName === 'SELECT');
    this.selects.forEach((select) => {
      select.addEventListener('change', this.handleFilterChange.bind(this));
    });
    this.updateSelectedOptions();
    
    // Dispatch initial filter state
    this.dispatchEvent(
      new CustomEvent('filter-initialized', {
        detail: { selectedOptions: this.selectedOptions },
        bubbles: true,
        composed: true,
      }),
    );
  }

  updateSelectedOptions() {
    this.selectedOptions = this.selects.map((select) =>
      select.value === select.options[0].value ? select.options[0].value : select.value,
    );
  }

  handleFilterChange() {
    this.updateSelectedOptions();
    this.dispatchFilterChangedEvent();
  }

  dispatchFilterChangedEvent() {
    this.dispatchEvent(
      new CustomEvent('filter-changed', {
        detail: { selectedOptions: this.selectedOptions },
        bubbles: true,
        composed: true,
      }),
    );
  }
}

customElements.define('events-filter', EventsFilter); 